module.exports = __webpack_public_path__ + "static/media/screencapture-cookbook-home-sqTiny.c598da30.png";